import Footer from "../../components/shared/Footer"
import Header from "../../components/shared/Header"
import AboutHero from "../../components/About/AboutHero"
function About() {
  return (

    <div>
      <Header/>
      <AboutHero/>
      <Footer/>
    </div>
  )
}

export default About